
// round a value to 3 decimals
export default {
	name: 'ZeroNullValueRound',
	handler: {
		init: function (element, valueAccessor, allBindingsAccessor) {
			let value = valueAccessor();
			// let allBindings = allBindingsAccessor();

			let valueUnwrapped = ko.utils.unwrapObservable(value);

			if (valueUnwrapped === 0 || valueUnwrapped === null || valueUnwrapped === undefined)
				$(element).text('-');
			else
				$(element).text(parseFloat(valueUnwrapped.toFixed(3)));
		}
	}
};
